module.exports = __webpack_public_path__ + "static/media/orobot-image.6cf88cab.png";